export const CELL_OVERFLOW_STYLES = {
  WRAP: 'wrap',
  NO_WRAP: 'no-wrap',
  ELLIPSIS: 'ellipsis',
};
export const DEFAULT_CELL_OVERFLOW_STYLE = CELL_OVERFLOW_STYLES.WRAP;
